import { postGetMemberContactDetails, postSendMembershipCardNumber } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import {
  GetMemberContactDetailsRequest,
  GetMemberContactDetailsResponse,
  SendMembershipCardNumberRequest,
  SendMembershipCardNumberResponse,
} from '@/interfaces/entities/roadside-assistance.interface';

export const RequestRoadsideAssistanceService = {
  /**
   * Get Member Contact Details
   * @param payload
   */
  async getMemberContactDetails(payload: GetMemberContactDetailsRequest): Promise<GetMemberContactDetailsResponse> {
    return await _http.HttpPost(postGetMemberContactDetails, payload);
  },

  /**
   * Send Membership Card Number
   * @param payload
   */
  async sendMembershipCardNumber(payload: SendMembershipCardNumberRequest): Promise<SendMembershipCardNumberResponse> {
    return await _http.HttpPost(postSendMembershipCardNumber, payload);
  },
} as const;
